import React, { Fragment, useState, useEffect } from 'react';
import {
    Grid,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Button,
    Paper,
    Box,
    InputLabel,
    Select,
    MenuItem

} from '@material-ui/core';
import { useStyles } from '../../styles/style';
import axios from 'axios';
import cogoToast from 'cogo-toast';
import CancelIcon from '@material-ui/icons/Cancel';
import {content_type} from '../bucket/objects'
import Switch from "react-switch";



export default function EditRadio(props) {
    const classes = useStyles();
    const [name, setName] = useState("");
    const [v0, setv0] = useState([]);
    const [v1, setv1] = useState([]);
    const [v2, setv2] = useState([]);
    const [v3, setv3] = useState([]);
    const [v4, setv4] = useState([]);
    const [v5, setv5] = useState([]);
    const [v6, setv6] = useState([]);
    const [v7, setv7] = useState([]);
    const [v8, setv8] = useState([]);
    const [v9, setv9] = useState([]);
    const [v10, setv10] = useState([]);
    const [continueToggle, setcontinueToggle] = useState(false)
    const [deletev0, setDeletev0] = useState([]);
    const [deletev1, setDeletev1] = useState([]);
    const [deletev2, setDeletev2] = useState([]);
    const [deletev3, setDeletev3] = useState([]);
    const [deletev4, setDeletev4] = useState([]);
    const [deletev5, setDeletev5] = useState([]);
    const [deletev6, setDeletev6] = useState([]);
    const [deletev7, setDeletev7] = useState([]);
    const [deletev8, setDeletev8] = useState([]);
    const [deletev9, setDeletev9] = useState([]);
    const [deletev10, setDeletev10] = useState([]);
    const [contents, setContents] = useState("");
    const [contentId, setContentId] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [langList, setLangList] = useState([{ code: "Default", name: "Default" }])
    const [lang, setLang] = useState("Default")

    const listVarient = ["v0","v1", "v2", "v3", "v4", "v5", "v6"];

    const handleChangeToggle = (e) =>{
        console.log('ee',e)
        setcontinueToggle(e)
    }
    const handlev0 = (e) => {
        setv0([...v0, ...e.target.files])
    }

    const fetchDataById = async () => {
        await axios.get(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/system/radio/${props.match.params.id}?storeId=${localStorage.getItem("storeId")}`)
            .then(res => {
                console.log('thumb',JSON.parse(res.data.result[0].data))
                setContentId(res.data.result[0].contentId)
                setDisplayName(res.data.result[0].vod_type)
                setName(res.data.result[0].title)
                setv0(res.data.result[0].v0)
                setContents(JSON.parse(res.data.result[0].data).url?JSON.parse(res.data.result[0].data).url:"")   
                setLang(res.data.result[0].language_id?res.data.result[0].language_id:"Default")
            }).catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        fetchDataById()
        fetchLanguage();
    }, [])

    const postVariant = async (data) => {
        const fd = new FormData();
        fd.append("lang", data.language);
        fd.append("type", data.type);
        fd.append("sectionId", data.sectionId);
        fd.append("name", data.name);
        fd.append("url", data.url);
        fd.append("vod_type", data.vod_type);
        fd.append("storeId", data.storeId);
        fd.append("content_type_id", data.content_type_id);
        data.deletev0.map((ele, i) => {
            fd.append(`deletev0[${i}]`, ele)
        })
        for (let index = 0; index < data.v0.length; index++) {
            const element = data.v0[index];
            if (typeof (element) !== "string") {
                fd.append('v0', element)
            }
        }
      
        await axios.put(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/system/radio/${props.match.params.id}`, fd,
            { headers: { "Content-Type": "multipart/form-data" } })
            .then(res => {
                cogoToast.success(res.data.message);
                props.history.push("/listRadio")
            }).catch(err => {
                cogoToast.error(err.response.data.message)
            })
    }

    const fetchLanguage = async () => {
        await axios.get(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/type/language?storeId=${localStorage.getItem("storeId")}`).then(res => {
            setLangList([...langList, ...res.data.result.result])
        }).catch(
            err => {
                console.log(err)
            }
        )
    }

    const onSubmit = () => {
        const obj = {
            "type": "radio",
            "v0": v0,
            name: name,
            contentId: contentId,
            deletev0: deletev0,
            url:contents,
            vod_type:displayName,
            "language": lang,
            "storeId":localStorage.getItem("storeId"),
            sectionId:"84",
            content_type_id:"live-radio"       
        }
        postVariant(obj)
        setDisplayName("")
        setContentId("")

    }

    const onClear = () => {
        setContentId("")
        setDisplayName("")
        setContentId("")
        setv0([])

    }
    const delete_v0 = (e, i, ele) => {
        let newArray = v0.filter((ele, index) => {
            return index !== i;
        })

        setDeletev0([...deletev0, ele]);

        setv0(newArray)
    }

    return (

        <Fragment>
            <Paper component={Box} p={4}>

                <div className="text-center">
                    <h1>Edit Radio</h1>
                    <Grid container >
                    {/* <Grid item md={8} sm={12}>
                <FormControl style={{minWidth:"45%",marginLeft:"-150px"}} variant="outlined" className={classes.formControl} >
                    <InputLabel id="demo-simple-select-outlined-label">Language</InputLabel>

                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={lang}
                        onChange={(e) => setLang(e.target.value)}
                        label="Language"
                    >
                        {
                            langList.length > 0 ?
                            langList.map((element, id) => {

                                    return (
                                        <MenuItem key={id} value={element.name}>{element.name}</MenuItem>
                                    )
                                }) :
                                <MenuItem disabled value="no Lamguage">No Lamguage</MenuItem>

                        }

                    </Select>

                </FormControl>

            </Grid> */}
            <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Language" name="language" value={lang} onChange={(e) => setLang(e.target.value)}></TextField>
                        </Grid>
                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Name" name="Name" value={name} onChange={(e) => setName(e.target.value)}></TextField>
                        </Grid>
                        <Grid item md={6}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="vod type" value={displayName} onChange={(e) => setDisplayName(e.target.value)}>
                            </TextField>
                        </Grid>
                        <Grid item md={6}>
                                                    <TextField variant="outlined" className={classes.inputField} width="25" required label="URL" value={contents} onChange={(e) => setContents(e.target.value)}></TextField>
                                                </Grid>
                        {/* <Grid item md={6}>
                        <FormControl variant="outlined" className={classes.formControl} >
                            <InputLabel id="demo-simple-select-outlined-label">Content Type</InputLabel>

                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={contents}
                                onChange={(e) => setContents(e.target.value)}
                                label="Content type"
                            >
                                {
                                    content_type && content_type.length > 0 ?
                                        content_type.map((element, id) => {

                                            return (
                                                <MenuItem key={id} value={element.typeid}>{element.Description}</MenuItem>
                                            )
                                        }) :
                                        <MenuItem disabled value="no pages">No Content Type</MenuItem>

                                }

                            </Select>

                        </FormControl>
                        </Grid> */}
 
                        <Grid item md={6} sm={12}>
                            <Button
                                className={classes.upload}
                                variant="outlined"
                                component="label"

                            >
                                v0 Thumbnail
                                <input
                                    multiple
                                    type="file"
                                    hidden
                                    onChange={handlev0}
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}
                                />
                            </Button>
                            {v0.length > 0 ?
                                (v0.map((ele, i) => <div><p className="mt-2 mr-4" onClick={() => window.open(ele.name ? null : `https://storage.googleapis.com/media-content-hungama-com/${ele}`, "_blank")} style={{ cursor: "pointer", display: "inline" }}>{ele.name ? ele.name : ele}</p><CancelIcon onClick={(e) => delete_v0(e, i, ele)} /></div>))
                                : null}
                                


                        </Grid>
                        <Grid item md={12}>
                            <Button type="submit" className="m-4" variant="contained" color="primary" onClick={onSubmit}>Update</Button>
                            <Button variant="contained" color="secondary" onClick={onClear}>Clear</Button>

                        </Grid>
                    </Grid>
                </div>
            </Paper>


        </Fragment>
    )
}
